import { render } from "./Tabs.vue?vue&type=template&id=bd83bf8c&scoped=true&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=bd83bf8c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd83bf8c"]])

export default __exports__